<!--========== 教学分析评估报告管理 ==========-->
<template>
    <div class="app-container">
        <el-card class="mb15" :body-style="{ padding: '10px' }">
            <div class="top1-container">
                <div class="top1-left">{{info.orgName}}
                    <span v-if="info.resourceType===0" style="font-size: 15px;color: #bd3124">(试用)</span>
                    <span v-if="info.resourceType===1" style="font-size: 15px;color: #67c23a">(正式)</span>
                </div>
                <div class="top1-right">{{info.totalCount - info.usedCount}}</div>
            </div>
            <div class="top2-container">
                <div class="top2-left">管理员:{{info.orgAdminName}}</div>
                <div class="top2-right">剩余次数</div>
            </div>
        </el-card>

        <el-card class="mb15" :body-style="{ padding: '10px' }">
            <div class="title-container">充值及消耗记录</div>
            <div class="bre9e mt15">
                <el-table header-cell-class-name="bgf2" show-overflow-tooltip
                          height="calc(100vh - 490px)"
                          :data="recordList"
                          highlight-current-row>
                    <el-table-column type="index" align="center" label="序号" width="60" />
                    <el-table-column align="center" label="操作时间" prop="createTime">
                        <template #default="scope">
                            <div>{{ timestampToTime(scope.row.createTime)}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="操作类型" prop="recordType">
                        <template #default="scope">
                            <div class="s-cz" v-if="scope.row.recordType===1">充值</div>
                            <div class="s-xh" v-if="scope.row.recordType===0">消耗</div>
                        </template>
                    </el-table-column>
                    <el-table-column  align="center" label="操作人">
                        <template #default="scope">
                            <div  v-if="scope.row.recordType===1">--</div>
                            <div  v-if="scope.row.recordType===0">{{scope.row.trueName}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column  align="center" label="充值人">
                        <template #default="scope">
                            <div  v-if="scope.row.recordType===1">{{scope.row.trueName}}</div>
                            <div  v-if="scope.row.recordType===0">--</div>
                        </template>
                    </el-table-column>
                    <el-table-column  align="center" label="次数变动">
                        <template #default="scope">
                            <div  v-if="scope.row.recordType===1">+{{scope.row.recordNum}}{{scope.row.resourceType===0?'(试用)':'(正式)'}}</div>
                            <div  v-if="scope.row.recordType===0">-{{scope.row.recordNum}}</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-card>

        <el-card class="mb15" :body-style="{ padding: '10px' }">
            <div class="title-container">订单记录</div>
            <div class="bre9e mt15">
                <el-table header-cell-class-name="bgf2" show-overflow-tooltip
                          height="calc(100vh - 490px)"
                          :data="taskList"
                          highlight-current-row>
                    <el-table-column type="index" align="center" label="序号" width="60" />
                    <el-table-column width="80" align="center" label="状态" prop="taskStatus">
                        <template #default="scope">
                            <div v-if="scope.row.taskStatus === '0'">待分析</div>
                            <div v-if="scope.row.taskStatus === '1'">分析中</div>
                            <div v-if="scope.row.taskStatus === '2'">已分析</div>
                            <div v-if="scope.row.taskStatus === '-1'">分析失败</div>
                        </template>
                    </el-table-column>
                    <el-table-column width="140" align="center" label="操作时间" prop="Time">
                        <template #default="scope">
                            <div>{{ timestampToTime(scope.row.createTime)}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column  align="center" label="操作人" prop="createUserName"></el-table-column>
                    <el-table-column width="160"  align="center" label="视频名称" prop="taskName" ></el-table-column>
                    <el-table-column  align="center" label="授课教师" prop="trueName"></el-table-column>
                    <el-table-column  align="center" label="学段" prop="periodName"></el-table-column>
                    <el-table-column  align="center" label="学科" prop="subjectName"></el-table-column>
                    <el-table-column width="160"  align="center" label="量表" prop="scaleName"></el-table-column>
                    <el-table-column fixed="right" width="120" label="操作" align="center">
                        <template #default="scope">
                            <el-button v-if="scope.row.taskType===1&&scope.row.taskStatus==='2'" type="primary" size="small" @click="handleDetail(scope.row)">查看报告</el-button>
                            <el-button v-if="scope.row.taskType===2&&scope.row.taskStatus==='2'" type="primary" size="small" @click="handleYxDetail(scope.row)">查看报告</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-card>
    </div>
</template>

<script>
import {timestampToTime} from "@/utils/date";
import {analyseDetail} from "@/api/admin/analyseResource"


export default {
    name: "analyseDetail",
    components: {},
    data() {
        return {
            timestampToTime,
            orgId:'',
            info:{},
            recordList:[],// 重置及消耗记录列表
            taskList:[],//分析任务列表
        };
    },
    created() {
        if (this.$route.query.signId) {
            this.orgId = this.$route.query.signId;
            this.queryAnalyseDetail()
        }
    },
    activated() {},
    watch: {},
    methods: {
        queryAnalyseDetail(){
            analyseDetail({orgId:this.orgId}).then(res => {
                if (res.data.code === 1) {
                    this.info = res.data.data;
                    this.recordList = this.info.recordList;
                    this.taskList = this.info.taskList;
                }else {
                    this.$message.error("请求出错");
                }
            })
        },
        handleDetail(row){
            this.$router.push({
                path: "/analyseReport",
                query: {
                    taskId: row.taskId,
                }
            });
        },
        handleYxDetail(row){
            this.$router.push({
                path: "/analyseReportInfo",
                query: {
                    taskId: row.taskId,
                }
            });
        }
    }
};
</script>
<style scoped>
.top1-container{
    width: 100%;
    height: 30px;
    display: flex;
}
.top1-left{
    width: calc(100% - 100px);
    height: 100%;
    font-size: 18px;
    font-weight: bold;
    font-family: sans-serif;
    text-align: left;
    color: #121212;
}
.top1-right{
    width: 100px;
    height: 100%;
    font-size: 18px;
    font-weight: bold;
    font-family: sans-serif;
    text-align: center;
    color: #4167f7;
}
.top2-container{
    width: 100%;
    height: 20px;
    display: flex;
}
.top2-left{
    width: calc(100% - 100px);
    height: 100%;
    font-size: 14px;
    font-family: sans-serif;
    text-align: left;
    color: #383838;
}
.top2-right{
    width: 100px;
    height: 100%;
    font-size: 14px;
    font-family: sans-serif;
    text-align: center;
    color: #383838;
}
.title-container{
    color:#121212;
    font-weight:bold;
    font-size:15px;
    font-family: sans-serif;
    height: 20px;
}
.s-cz{
    font-family: sans-serif;
    font-size: 12px;
    color: #fff;
    width: 46px;
    height: 24px;
    line-height: 24px;
    border-radius: 4px;
    text-align: center;
    background-color: #67c23a;
    margin: auto;
}
.s-xh{
    font-family: sans-serif;
    font-size: 12px;
    color: #fff;
    width: 46px;
    height: 24px;
    line-height: 24px;
    border-radius: 4px;
    text-align: center;
    background-color: #bd3124;
    margin: auto;
}
</style>
